import React, {FC, useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './PublishButton.module.scss';
import {selectMe} from './../../features/stores/user.slice';
import {store} from './../../app/store';
import {useSelector} from 'react-redux';
import {selectChangeData, setShouldSave} from './../../features/stores/changeData.slice';
import {useAppSelector} from '../../app/hooks';
import {selectMediakitUser} from '../../features/stores/mediakitUser.slice';
import {envConfig} from '../../API/enviromentVariables';

const PublishButton = () => {
    const url = envConfig().copyLinkUrl;
    const linksUser = useSelector(selectMediakitUser);
    const {t, i18n} = useTranslation();
    const user = selectMe(useAppSelector(store.getState)).me;
    const dataChange = useSelector(selectChangeData);
    const handleSave = () => {
        if (dataChange) {
          store.dispatch(setShouldSave(true));
        }
    };
    return (
        <>
        <div className={`${styles.publish} ${dataChange ? '' : styles.disabled}`} onClick={handleSave}>{t('publish')}</div>
        <a className={styles.anchor} href={`${url}/${linksUser?.nickname?.toLowerCase()}`}><div className={styles.view_profile}>{t('view_public_profile')}</div></a>
        </>
    );
};

export default PublishButton;
